/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import Story from "./story";
import OldTextStory from "../text-story/old";
import OldPhotoStory from "../photo-story/old";
import OldVideoStory from "../video-story/old";
import OldListicleStory from "../listicle-story/old";
import OldLiveBlogStory from "../live-blog/old";
import StoryRowWrapper from "../story-row-wrapper.js";

export const StoryWrapper = props => {
  const { config, storyStoreField, storyPageType, storyBaseType } = props;
  const storyToggle = {
    "text-story": "storyPage",
    "photo-story": "photoStoryPage",
    "video-story": "videoStoryPage",
    "liveBlog-story": "liveBlogStoryPage",
    "listicle-story": "listicleStoryPage"
  };
  // adding the below object as the storyPageType for custom story will be different, so handling that w.r.t custom story's storyBaseType
  // can remove this toggle check when we get rid of the ahead templates

  const customBaseTypeToggle = {
    text: "storyPage",
    photo: "photoStoryPage",
    video: "videoStoryPage",
    "live-blog": "liveBlogStoryPage",
    listicle: "listicleStoryPage"
  };
  const toggleName = storyToggle[storyPageType] || customBaseTypeToggle[storyBaseType];
  const isPbStoryEnabled = get(config, ["pagebuilder-config", "featureToggle", toggleName], false);
  if (isPbStoryEnabled) {
    const storyRows = get(config, ["pagebuilder-config", storyStoreField, storyPageType, "rows"], []);
    return (
      <StoryRowWrapper rows={storyRows}>
        <Story {...props} />
      </StoryRowWrapper>
    );
  }
  switch (storyPageType) {
    case "text-story":
      return <OldTextStory {...props} />;
    case "photo-story":
      return <OldPhotoStory {...props} />;
    case "video-story":
      return <OldVideoStory {...props} />;
    case "liveBlog-story":
      return <OldLiveBlogStory {...props} />;
    case "listicle-story":
      return <OldListicleStory {...props} />;
    default:
      return <OldTextStory {...props} />;
  }
};

StoryWrapper.propTypes = {
  config: PropTypes.object,
  storyStoreField: PropTypes.string,
  storyPageType: PropTypes.string,
  storyBaseType: PropTypes.string
};

StoryWrapper.defaultProps = {
  storyStoreField: "story",
  storyPageType: "text-story"
};
export default StoryWrapper;
